import { translate } from '../../common/helpers/translate.helper';

import type { OfferChatMessage } from './types';

export const getSenderNameBySenderType = (message: OfferChatMessage): string => {
    const unknownSender = translate('global.unknown');

    switch (message.senderType) {
        case 'CUSTOMER':
            return message.customer?.name || unknownSender;
        case 'SUPPLIER':
            return message.supplier?.name || unknownSender;
        case 'USER':
            return `${message.user?.firstname || ''} ${message.user?.lastname || ''}`.trim() || unknownSender;
        case 'SYSTEM':
        default:
            return translate('global.system');
    }
};
